module.exports = __webpack_public_path__ + "static/img/news8.1913131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news8.jpg
// module id = bDw2
// module chunks = 1